import connect from 'react-redux/es/connect/connect';

import { updateBooker } from '../actions/cart';
import BookerFields from '../components/BookerFields';

const mapStateToProps = state => {
    return {
        cartItems: state.cart.cartItems,
        booker: state.cart.booker,
        user: state.user.user
    };
};

const mapDispatchToProps = dispatch => ({
    updateBookingGuest: guest => {
        dispatch(updateBooker(guest));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(BookerFields);
